import { apiCall } from './_helper';

//--------------Account Details--------------------//

//Deletes a company account. Requires some very fancy settings to be viewable.
// Tested and working: 4/6/2025
export const deleteCompanySettings = async (companyId) => {
  return await apiCall({
    url: 'company/deleteCompany/' + companyId,
    method: 'DELETE',
    headers: {
      origin: window.origin,
    },
    notJSON: true,
  });
};

// Gets account details for a company
// Tested and working: 4/6/2025
export const getAccountDetails = async (companyId) => {
  return await apiCall({
    url: 'accountDetails/getDetails?companyId=' + companyId,
    notJSON: true,
  });
};

// Updates account details for a company
// Tested and working: 4/6/2025
export const updateAccountDetailsApi = async (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  return await apiCall({
    url: 'accountDetails/company',
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};
//--------------Terms and Condition Details--------------------//
export const getEnvelopeDetails = async (companyId) => {
  return await apiCall({
    url: `company/getEnvelopeDetails/${companyId}`,
    notJSON: true,
  });
};

export const revisitEnvelope = async (envelopeId, companyId) => {
  return await apiCall({
    url: `company/revisitEnvelope?envelopeId=${envelopeId}&companyId=${companyId}`,
    notJSON: true,
  });
};

//--------------User Details--------------------//

// Gets a list of users for a company for user maintenance
// Tested and working: 4/6/2025
export const getUserDetails = async (companyId) => {
  return await apiCall({
    url: 'users/getUser?companyId=' + companyId,
    notJSON: true,
  });
};

// Gets a list of roles for a company for user maintenance
// Tested and working: 4/6/2025
export const getUserRoles = async (companyId) => {
  return await apiCall({
    url: 'users/roles?companyId=' + companyId,
    notJSON: true,
  });
};

// Updates user details for a company
// Tested and working: 4/6/2025
export const putUserDetails = async (userData, companyId) => {
  const formData = new FormData();
  formData.append('emailAddress', userData.userEmail);
  formData.append('roleId', userData.roleId);
  formData.append('firstname', userData.firstname || '');
  formData.append('lastname', userData.lastname || '');
  formData.append('mfaEnable', userData.mfaEnable ?? true);
  return await apiCall({
    url: 'users/updateUser?companyId=' + companyId,
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};

// Creates a new user for a company
// Tested and working: 4/6/2025
export const postUserDetails = async (userData, companyId) => {
  const formData = new FormData();
  formData.append('emailAddress', userData.userEmail);
  formData.append('roleId', userData.roleId);
  formData.append('firstname', userData.firstname || '');
  formData.append('lastname', userData.lastname || '');
  formData.append('mfaEnable', userData.mfaEnable ?? true);
  return await apiCall({
    url: 'users/createUser?companyId=' + companyId,
    method: 'POST',
    body: formData,
    notJSON: true,
  });
};

// Toggles the status of a user (enable/disable)
// Tested and working: 4/6/2025
export const disableUser = async (emailId) => {
  return await apiCall({
    url: 'users/toggleStatus?email=' + encodeURIComponent(emailId),
    notJSON: true,
  });
};

// Resends invite email for invited users
// Tested and working: 01/08/2025
export const resendUserInvite = async (companyId, emailAddress, firstname) => {
  const formData = new FormData();
  formData.append('emailAddress', emailAddress);
  formData.append('firstname', firstname);
  return await apiCall({
    url: `users/resendInvite?companyId=${companyId}`,
    method: 'POST',
    body: formData,
    notJSON: true,
  });
};

//--------------Trader Details--------------------//

// Gets a list of traders for a company for trader maintenance
// Tested and working: 4/6/2025
export const getTraderDetails = async (companyId) => {
  return await apiCall({
    url: 'traders/traderList?companyId=' + companyId,
    notJSON: true,
  });
};

// Updates trader details for a company
// Tested and working: 4/6/2025
export const putTraderDetails = async (userData, companyId) => {
  const formData = new FormData();
  formData.append('Id', userData.Id);
  formData.append('RefType', userData.RefType);
  formData.append('CompanyName', userData.CompanyName);
  formData.append('EORI', userData.EORI);
  formData.append('StreetAddress', userData.StreetAddress);
  formData.append('PostalCode', userData.PostalCode);
  formData.append('Country', userData.CountryCode);
  formData.append('City', userData.City);
  formData.append('streetNumber', userData.streetNumber || '');
  formData.append('isConsignor', userData.isConsignor || false);
  formData.append('isConsignee', userData.isConsignee || false);
  formData.append('isCarrier', userData.isCarrier || false);

  return await apiCall({
    url: 'traders/updateTrader?companyId=' + companyId,
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};

// Currently not in use. Functionality commented out in the UI
export const postTraderDetails = async (userData) => {
  return await apiCall({
    url: 'traders/',
    method: 'POST',
    body: JSON.stringify(userData),
  });
};

// Deletes a trader for a company
// Tested and working: 4/6/2025
export const deleteTrader = async (traderData, companyId) => {
  const formData = new FormData();
  formData.append('Id', traderData.id);
  formData.append('RefType', traderData.refType);

  return await apiCall({
    url: 'traders/deleteTrader?companyId=' + companyId,
    method: 'DELETE',
    body: formData,
    notJSON: true,
  });
};

// Restores a company
export const restoreCompany = async (companyId, companyName, companyEori) => {
  const formData = new FormData();
  formData.append('companyId', companyId);
  formData.append('company', companyName);
  formData.append('eori', companyEori);
  return await apiCall({
    url: 'accountDetails/restoreCompany',
    method: 'POST',
    body: formData,
    notJSON: true,
  });
};

// --------------Subscription Details--------------------//

// Gets subscription details for a company
export const getSubscriptionDetails = async (companyId) => {
  return await apiCall({
    url: 'subscription/details/' + companyId,
    notJSON: true,
  });
};

// Get subscription pricing tiers
export const getUnitPricingTier = async () => {
  return await apiCall({
    url: 'accountDetails/getUnitPricingTier',
    notJSON: true,
  });
};

// Currently not in use. Functionality commented out in the UI
export const requestAdditionalUnits = async (data) => {
  return await apiCall({
    url: 'accountDetails/requestAdditionalUnits',
    method: 'POST',
    body: JSON.stringify(data),
  });
};

// Currently not in use. Functionality commented out in the UI
export const getCurrentBalance = async (companyId) => {
  return await apiCall({
    url: 'accountDetails/currentBalance/' + companyId,
    notJSON: true,
  });
};

// Gets amendment types for balances
export const getBalanceAmendmentTypes = async (companyId) => {
  return await apiCall({
    url: 'referencedata/amendmentTypes',
    notJSON: true,
  });
};

// Amends balance for a company
export const amendBalance = async (data) => {
  return await apiCall({
    url: 'accountDetails/amendBalance',
    method: 'POST',
    body: JSON.stringify(data),
  });
};

// Get subscription history for a company
export const getSubscriptionHistory = async (companyId) => {
  return await apiCall({
    url: 'subscription/history/' + companyId,
    notJSON: true,
  });
};

// Get maintenance banner info for display (based on logged in user's department)
export const getMaintenance = async () => {
  return await apiCall({
    url: 'banner/info',
    notJSON: true,
    noAuth: !sessionStorage.getItem('token'),
  });
};

// Get maintenance banner details for IT admin configuration
export const getMaintenanceBannerDetails = async () => {
  return await apiCall({
    url: 'banner/details',
    notJSON: true,
  });
};

// Create/Update maintenance banner details (IT only)
export const putMaintenanceBannerDetails = async (data) => {
  const formData = new FormData();
  formData.append('enabled', data.enabled ? 1 : 0);
  formData.append('bannerText', data.bannerText);
  formData.append('moreInfo', data.moreInfo);
  formData.append('startDate', data.startDate);
  formData.append('endDate', data.endDate);
  formData.append('visibility', data.visibility);

  return await apiCall({
    url: 'banner/details',
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};
